import { resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-70a38c42"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "oxd-date-wrapper" }
const _hoisted_2 = { class: "oxd-date-input" }
const _hoisted_3 = {
  key: 0,
  class: "oxd-date-input-calendar"
}
const _hoisted_4 = { class: "oxd-date-input-links" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_oxd_input = _resolveComponent("oxd-input")!
  const _component_oxd_icon = _resolveComponent("oxd-icon")!
  const _component_oxd_calendar = _resolveComponent("oxd-calendar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_oxd_input, {
        hasError: _ctx.hasError,
        disabled: _ctx.disabled,
        readonly: _ctx.readonly,
        onBlur: _ctx.onBlur,
        "onUpdate:modelValue": _ctx.onDateTyped,
        onClick: _ctx.toggleDropdown,
        value: _ctx.displayDate,
        placeholder: _ctx.placeholder,
        ref: "oxdInput"
      }, null, 8, ["hasError", "disabled", "readonly", "onBlur", "onUpdate:modelValue", "onClick", "value", "placeholder"]),
      _createVNode(_component_oxd_icon, {
        class: _normalizeClass(_ctx.dateIconClasses),
        name: "calendar",
        onClick: _ctx.toggleDropdown
      }, null, 8, ["class", "onClick"])
    ]),
    _createVNode(_Transition, { name: "transition-fade-down" }, {
      default: _withCtx(() => [
        (_ctx.open)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createVNode(_component_oxd_calendar, _mergeProps(_ctx.$attrs, {
                "onUpdate:modelValue": [
                  _ctx.onDateSelected,
                  _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dateSelected) = $event))
                ],
                onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"])),
                modelValue: _ctx.dateSelected,
                locale: _ctx.locale
              }), {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", {
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClickToday && _ctx.onClickToday(...args))),
                      class: "oxd-date-input-link --today"
                    }, _toDisplayString(_ctx.t('general.today', 'Today')), 1),
                    _createElementVNode("div", {
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClickClear && _ctx.onClickClear(...args))),
                      class: "oxd-date-input-link --clear"
                    }, _toDisplayString(_ctx.t('general.clear', 'Clear')), 1),
                    _createElementVNode("div", {
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args))),
                      class: "oxd-date-input-link --close"
                    }, _toDisplayString(_ctx.t('general.close', 'Close')), 1)
                  ])
                ]),
                _: 1
              }, 16, ["onUpdate:modelValue", "modelValue", "locale"])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}